import React from "react";

const SectionHeader = ({
  title,
  description,
  para,
  textalign,
  color,
  justify,
  width,
}) => {
  return (
    <div className={`flex justify-center w-full items-center`}>
      <div
        className={`flex flex-col items-${justify || "center"} gap-3 md:gap-4 text-center`}
      >
        {title && (
          <p className="text-[13px] md:text-[14px] font-[600] text-[#1167D0] tracking-widest uppercase">
            {title}
          </p>
        )}
        {description && (
          <h2 className="text-[22px] md:text-[36px] text-[#0D121F] font-[800] font-avenir leading-tight">
            {description}
          </h2>
        )}
        {para && (
          <p
            className={`text-${textalign} w-full md:w-8/12 text-[#6B7280] text-[14px] md:text-[16px] mx-auto`}
          >
            {para}
          </p>
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
